import { defineStore } from 'pinia';
import { userStoreEntity } from 'freedom-shared';

import { api } from '@/shared/api';
import { sentryModel } from '@/shared/model';
import { bloomreachLib } from '@/shared/lib';

export const useUserStore = defineStore('user-store', () => {
  const userStore = userStoreEntity.model.useUserStore(api);

  const getUserId = () => {
    return userStore
      .getUserId()
      .then(userId => {
        bloomreachLib.identify({ userId });

        sentryModel.addBreadcrumb({
          message: 'Authorization completed',
          level: sentryModel.level.INFO,
        });

        return userId;
      })
      .catch(err => {
        sentryModel.captureException(
          sentryModel.getReadableError(
            sentryModel.createCustomErrorText(
              sentryModel.errorPrefix.DEFAULT,
              'AUTHORIZATION_FAILED',
            ),
            err,
          ),
          { level: sentryModel.level.FATAL },
        );
      });
  };

  return { ...userStore, getUserId };
});
